export default __webpack_public_path__ + "static/media/loading.95be6e88.gif";